import { Component } from '@angular/core';
import { ORCIDFundingEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Fundings') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-orcidfunding-form',
    templateUrl: './orcidfunding.form.component.html'
})
export class ORCIDFundingFormComponent extends BaseFormComponent {
    public record!: ORCIDFundingEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'fundingExternalIDs', sectionName: 'Funding External IDs', isExpanded: false }
        ]);
    }
}

